// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__19mzg","productName":"Table_productName__2JeKK"};